import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, catchError, map, tap, throwError } from 'rxjs';
import { Tribunal } from './tribunal.model';
import { environment } from 'src/environments/environment';
import urlJoin from 'url-join';
import { ActivatedRoute } from "@angular/router";
import { NotificationsService } from '../core/service/notifications.service';

@Injectable({
  providedIn: 'root' // Poner aquí esta declaración hace que no sea necesario meterlo en providers de app.module
})
export class ParticipantesService {

  private participantesURL: string = urlJoin(environment.apiURL, 'participantes')
  private usuariosURL: string = urlJoin(environment.apiURL, 'usuarios')

  constructor(
    private http: HttpClient,
    private route: ActivatedRoute,
    private notificationsService: NotificationsService
  ) { }

  getTribunales(id_expediente: string): Observable<Tribunal[]> {
    const getparticipantesURL = urlJoin(this.participantesURL, '/expediente/', id_expediente)
    return this.http.get<Tribunal[]>(getparticipantesURL)
      .pipe(
        tap(() => {
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  getTribunal(id: string): Observable<any> {
    const getTribunalURL = urlJoin(this.participantesURL, id)
    return this.http.get<Tribunal>(getTribunalURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  updateTribunal(id: string, Tribunal: Tribunal): Observable<any> {
    const updateTribunalURL = urlJoin(this.participantesURL, id)
    return this.http.put<Tribunal>(updateTribunalURL, Tribunal)
      .pipe(
        tap(() => {
          const updateTribunalSuccessMessage: string = $localize`:@@updateTribunalSuccessMessage:Participante modificado correctamente`;
          this.notificationsService.showSuccessNotification(updateTribunalSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  deleteTribunal(id: string): Observable<any> {
    const deleteTribunalURL = urlJoin(this.participantesURL, id)
    return this.http.delete<Tribunal>(deleteTribunalURL)
      .pipe(
        tap(() => {
          const deleteTribunalSuccessMessage: string = $localize`:@@deleteTribunalSuccessMessage:Participante eliminado correctamente`;
          this.notificationsService.showSuccessNotification(deleteTribunalSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  checkEmail(email: string): Observable<any> {
    const checkEmailURL = urlJoin(this.usuariosURL, email, "/existeEmail")
    return this.http.get<boolean>(checkEmailURL)
      .pipe(
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

  newTribunal(Tribunal: Tribunal): Observable<any> {
    const newTribunalURL = urlJoin(this.participantesURL, "/expediente")
    return this.http.post<Tribunal>(newTribunalURL, Tribunal)
      .pipe(
        tap(() => {
          const newTribunalSuccessMessage: string = $localize`:@@newTribunalSuccessMessage:Nuevo participante añadido correctamente`;
          this.notificationsService.showSuccessNotification(newTribunalSuccessMessage);
        }),
        catchError(error => {
          this.notificationsService.showErrorNotification(error);
          return throwError(() => error)
        })
      )
  }

}
